<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <tablesready-custom-fields
    #partyCustomFields
    [fields]="controls"
    [savedFields]="savedCustomFields"
    [submitting]="submitting"
    [fullSize]="isDesktop"
    [sideMenuWidth]="sideMenuWidth"
    [maxSelectOptionsToDisplay]="maxSelectOptionsToDisplay"
    [reservationPlural]="reservationPlural"
    (addNew)="add()"
    (submitted)="submit()"
    (reverted)="resetCustomFields()"
    (fieldMoved)="moveField($event)"
    (fieldRemoved)="remove($event)"
  ></tablesready-custom-fields>

</section>
